import React from 'react'
import {Button, Card} from "antd";
import {Link, Router} from "@reach/router";
import OfferCreateContainer from "./create/OfferCreateContainer";
import OfferList from "./read/OfferList";
import OfferUpdateContextContainer from "./update/OfferUpdateContextContainer";
import OfferDetailContainer from "./detail/OfferDetailContainer";
import './offer.sass'

const OfferContainer = () => {

    return (
        <React.Fragment>
            <Card
                title={window.location.pathname.includes('detail') ? null : 'Teklif Listesi'}
                extra={!window.location.pathname.includes('create') ?
                    <Button
                        type={'primary'}
                    >
                        <Link to={'create'}>
                            Yeni Ekle
                        </Link>
                    </Button>
                    : null
                }
            >
                <Router>
                    <OfferList path={'/list'}/>
                    <OfferCreateContainer path={'/create'}/>
                    <OfferUpdateContextContainer path={'/update/:offerId'}/>
                    <OfferDetailContainer path={'/detail/:offerId'} />
                </Router>
            </Card>
        </React.Fragment>
    )
}
export default OfferContainer